import { captureException } from '@sentry/react'
import { ErrorKeys } from 'consts/errorKeys'
import { TAppDispatch } from 'store/types'
import { IUploadMediaItem } from 'types/media'
import { ApiError, ReduxThunkError } from 'utils/errors'
import { handleApiError } from 'store/utils'
import { uploadFile_API } from 'api'
import { mapMediaInputAndOutput } from 'utils/media'
import { IMediaFile } from 'store/features/projectData/thunks/media'
import slice from 'store/features/aiAvatar/slice'
import { AvatarSource } from 'store/types/aiAvatar'
import { buildUploadFormData } from 'store/features/aiAvatar/utils'

const { actions } = slice

// Uploads the file straight to the file-upload endpoint and keeps the result
// only in the avatar redux. It intentionally does NOT go through
// projectDataThunks.uploadMedias — the avatar isn't a project media item, so it
// shouldn't touch project media / recently-used state.
const uploadAvatar =
  (uploadItems: IUploadMediaItem[]) => async (dispatch: TAppDispatch) => {
    dispatch(actions.setAvatarLoading(true))

    try {
      const formData = buildUploadFormData(uploadItems)

      const response = await uploadFile_API(formData)
      const uploadedMedias: IMediaFile[] = mapMediaInputAndOutput(
        uploadItems,
        response
      )
      const uploadedMedia = uploadedMedias[0]

      if (uploadedMedia) {
        dispatch(
          actions.setAvatar({
            id: uploadedMedia.id,
            url: uploadedMedia.filePath,
            source: AvatarSource.UPLOAD,
            width: uploadedMedia.width,
            height: uploadedMedia.height
          })
        )
      } else {
        dispatch(actions.clearAvatar())
      }
    } catch (error) {
      dispatch(actions.clearAvatar())
      if (!(error instanceof ApiError)) {
        captureException(new ReduxThunkError(error))
      }
      dispatch(handleApiError(ErrorKeys.GENERAL_API_ERROR))
    } finally {
      dispatch(actions.setAvatarLoading(false))
    }
  }

export const uploadThunks = {
  uploadAvatar
}
